import { useState, useCallback } from "react";

/**
 * Jednoduchý hook pro správu stavového automatu (FSM).
 * * @param {string} initial - Počáteční stav stroje.
 * @param {Object} transitions - Mapa stavů a jejich povolených přechodů.
 * Příklad: { 'idle': { 'START': 'loading' } }
 * @returns {Array} Pole s [currentState, sendEvent]
 */
const useSimpleMachine = (initial, transitions) => {
  // 1. Stav pro uchování aktuálního stavu stroje
  const [currentState, setCurrentState] = useState(initial);

  // 2. Funkce pro odeslání události (triggeru)
  // Používáme useCallback pro stabilní referenci funkce
  const sendEvent = useCallback(
    (event) => {
      // Zjistíme, zda existuje aktuální stav v mapě přechodů
      const currentTransitions = transitions[currentState];

      if (!currentTransitions) {
        console.warn(`[FSM] Stav "${currentState}" nemá definované žádné přechody.`);
        return;
      }

      // Zjistíme, zda je pro daný stav povolena daná událost (event)
      const nextState = currentTransitions[event];

      if (nextState) {
        // Pokud je přechod povolen, aktualizujeme stav
        //console.log(`[FSM] Přechod: ${currentState} -> ${nextState} pomocí události ${event}`);
        setCurrentState(nextState);
      } else {
        // Přechod není pro tento stav povolen
        //console.warn(`[FSM] Chyba: Událost "${event}" není povolena ze stavu "${currentState}".`);
      }
    },
    [currentState, transitions]
  ); // Závislosti zajistí, že hook správně reaguje na změny

  const reset = useCallback((resetState) => {
    console.log("Resetování stroje na hodnotu:", resetState);
    setCurrentState(resetState);
  }, []);

  // 3. Vrátíme aktuální stav a funkci pro odeslání události
  return [currentState, sendEvent, reset];
};

export default useSimpleMachine;
